import { ViewportScroller } from '@angular/common';
import { ChangeDetectionStrategy, Component, DOCUMENT, ElementRef, inject, signal, viewChildren } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { ListeAccordeon } from '@components/liste-accordeon/models';
import { ButtonComponent } from '@shared/components/button';
import { ImageComponent } from '@shared/components/image';
import { SvgComponent } from '@shared/components/svg';
import { VideoComponent } from '@shared/components/video';
import { YoutubePlayerComponent } from '@shared/components/youtube-player';
import { YoutubeIdExtractorPipe } from '@shared/components/youtube-player/pipes';
import { HandleHtmlLinksDirective } from '@shared/directives';
import { IsImagePipe, IsVideoPipe } from '@shared/pipe';

@Component({
  selector: 'app-liste-accordeon',
  templateUrl: './liste-accordeon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SvgComponent,
    ImageComponent,
    HandleHtmlLinksDirective,
    ButtonComponent,
    VideoComponent,
    IsImagePipe,
    IsVideoPipe,
    YoutubePlayerComponent,
    YoutubeIdExtractorPipe,
  ],
})
export class ListeAccordeonComponent extends AbstractDynamicComponent<ListeAccordeon> {
  protected readonly openedItemIndex = signal<number>(0);
  protected readonly accordionItems = viewChildren<ElementRef>('accordionItem');
  private readonly viewportScroller = inject(ViewportScroller);
  private readonly window = inject(DOCUMENT).defaultView as Window;

  toggleItemOpen(index: number): void {
    const currentOpenedIndex = this.openedItemIndex();
    if (currentOpenedIndex === index) {
      this.openedItemIndex.set(-1);
    } else {
      this.openedItemIndex.set(index);
      this.scrollToItem(index);
    }
  }

  private scrollToItem(index: number): void {
    this.window.setTimeout(() => {
      const items = this.accordionItems();
      if (items && items[index]) {
        const element = items[index].nativeElement as HTMLElement;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + this.window.pageYOffset - 140;

        this.viewportScroller.scrollToPosition([0, offsetPosition], { behavior: 'smooth' });
      }
    }, 100);
  }
}
